// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { LocalizationProvider } from './locales';
import { SnackbarProvider } from 'notistack';
import { useEffect } from 'react';
import { AnalyticsProvider } from 'src/contexts/analytics/analyticsProvider';
//
import OneSignal from 'react-onesignal';
import { ChatProvider } from 'src/contexts/chat/chatprovider';
import { CallProvider } from 'src/contexts/call/callprovider';
import NotificationProvider from './contexts/notification/notificationprovider'; 
// ----------------------------------------------------------------------

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]' // IPv6 loopback
);

export default function App() {
  const charAt = `

  ░░░    ░░░
  ▒▒▒▒  ▒▒▒▒
  ▒▒ ▒▒▒▒ ▒▒
  ▓▓  ▓▓  ▓▓
  ██      ██

  `;

  console.info(`%c${charAt}`, 'color: #5BE49B');

  useScrollToTop();

  // useEffect(() => {
  //   // Ensure this code runs only on the client side
  //   if (typeof window !== 'undefined') {
  //     const isSupported = OneSignal.Notifications.isPushSupported();

  //     if(isSupported){
  //       if(process.env.REACT_APP_ENV === "Staging"){
  //         if(isLocalhost){
  //           console.log("Onesignal initialization stopped due to localhost...");
  //           return;
  //         }

  //         console.log("Onesignal staging initialization...");
  
  //         OneSignal.init({
  //           appId: process.env.REACT_APP_ONE_SIGNAL_ID,
  //           // You can add other initialization options here
  //           notifyButton: {
  //             enable: true,
  //           },
  //           serviceWorkerParam: { scope: "/push/client_dev/" },
  //           serviceWorkerPath: "/push/client_dev/OneSignalSDKWorker.js",
  //           // Uncomment the below line to run on localhost. See: https://documentation.onesignal.com/docs/local-testing
  //           allowLocalhostAsSecureOrigin: true
  //         });
  //       }
  //       else if(process.env.REACT_APP_ENV === "Live"){
  //         console.log("Onesignal live initialization...");
  
  //         OneSignal.init({
  //           appId: process.env.REACT_APP_ONE_SIGNAL_ID,
  //           // You can add other initialization options here
  //           notifyButton: {
  //             enable: true,
  //           },
  //           serviceWorkerParam: { scope: "/push/client_live/" },
  //           serviceWorkerPath: "/push/client_live/OneSignalSDKWorker.js"
  //         });
  //       }
  //     }
  //     else{
  //       console.log("Browser not supports web push...");
  //     }
  //   }
  // }, []);

  return (
    <AuthProvider>
      <AnalyticsProvider>
        <LocalizationProvider>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'light', // 'light' | 'dark'
              themeDirection: 'ltr', //  'rtl' | 'ltr'
              themeContrast: 'default', // 'default' | 'bold'
              themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
              themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
              themeStretch: false,
            }}
          >
            <ThemeProvider>
              <SnackbarProvider>
                <MotionLazy>
                  <SettingsDrawer />
                  <ProgressBar />
                  <AuthConsumer>
                    <ChatProvider>
                      <CallProvider>
                        <NotificationProvider>
                          <Router />
                        </NotificationProvider>
                      </CallProvider>
                    </ChatProvider>
                  </AuthConsumer>
                </MotionLazy>
              </SnackbarProvider>
            </ThemeProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </AnalyticsProvider>
    </AuthProvider>
  );
}
